export const environment = {
    production: true,
    assetsPath: '/widgets/olb-login-alert-widget/assets',
    translationPath: '/widgets/olb-login-alert-widget/',
    appBaseHref: '',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts